import { useQuery } from "@tanstack/react-query";

import { airtimeApi } from "./api";

export function useAirtimeStats() {
  return useQuery({
    queryKey: ["airtime", "stats"],
    queryFn: airtimeApi.getStats,
  });
}

export function useAirtimeConfig() {
  return useQuery({
    queryKey: ["airtime", "config"],
    queryFn: airtimeApi.getConfig,
  });
}

export function useAirtimeAllocations(params: {
  page: number;
  size: number;
  search?: string;
}) {
  return useQuery({
    queryKey: ["airtime", "allocations", params],
    queryFn: () =>
      airtimeApi.listAllocations(params),
  });
}

export function useMyAirtimeAllocation() {
  return useQuery({
    queryKey: ["airtime", "my-allocation"],
    queryFn: airtimeApi.getMyAllocation,
  });
}

export function useAirtimeBatches(params: {
  page: number;
  size: number;
}) {
  return useQuery({
    queryKey: ["airtime", "batches", params],
    queryFn: () =>
      airtimeApi.listBatches(params),
  });
}